const useGetColorGradient = (cardColor: string | null) => {
  switch (cardColor) {
    case '#F55A58':
      return ['#F55A58', '#C8403E'];
    case '#FC9342':
      return ['#FC9342', '#C66F2C'];
    case '#F5BA02':
      return ['#F5BA02', '#C69500'];
    case '#C9A357':
      return ['#C9A357', '#9E7C3C'];
    case '#2349E5':
      return ['#2349E5', '#102C9D'];
    case '#8300E8':
      return ['#8300E8', '#5B00A6'];
    case '#312F3B':
      return ['#312F3B', '#1F1E26'];
    case '#3DB512':
    default:
      return ['#3DB512', '#0A5421'];
  }
};

export default useGetColorGradient;
